module.exports = {
	"pagination": {
		"DescribeAlarmHistory": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AlarmHistoryItems"
		},
		"DescribeAlarms": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "MetricAlarms"
		},
		"DescribeAlarmsForMetric": {
			"result_key": "MetricAlarms"
		},
		"ListMetrics": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Metrics"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/monitoring-2010-08-01.paginators.json
// module id = 1367
// module chunks = 0